import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Camera, Heart, Sparkles } from 'lucide-react';
import { fraseDelDia } from '../config/caminoFrases';

const INSTAGRAM_URL = 'https://www.instagram.com/spanischenlared/';

export const CaminoThanks = ({ accent, slug }) => {
  const frase = fraseDelDia();
  return (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35 }}
    id="camino-thanks"
    data-testid={`camino-thanks-${slug}`}
    className="max-w-2xl mx-auto mt-2 mb-8 rounded-2xl bg-white border border-black/5 shadow-lg overflow-hidden"
  >
    <div className="px-6 py-5" style={{ background: `${accent}22` }}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-white shadow-sm">
          <Heart className="w-5 h-5" style={{ color: accent }} />
        </div>
        <div>
          <p className="font-extrabold text-base text-[#2F2F2F]">¡Gracias por descargarla!</p>
          <p className="mt-1 text-sm text-gray-700 leading-relaxed">
            He creado este recurso para acompañarte durante el Camino. Si te ha ayudado y te ha gustado,
            me encantaría saber dónde encontraste mi pegatina.
          </p>
        </div>
      </div>
    </div>
    <div className="px-6 py-5 space-y-4">
      <div className="flex items-start gap-3">
        <Camera className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#7DBDD9]" />
        <p className="text-sm text-gray-700 leading-relaxed">
          Comparte una foto en Instagram y etiquétame:{' '}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="camino-thanks-handle"
            className="font-bold text-[#2F2F2F] underline decoration-[#7DBDD9] decoration-2 underline-offset-2"
          >
            @spanischenlared
          </a>
        </p>
      </div>
      <div className="rounded-xl border-2 border-dashed px-4 py-4" style={{ borderColor: `${accent}99`, background: `${accent}14` }} data-testid="camino-frase-del-dia">
        <p className="text-[11px] font-bold tracking-widest uppercase flex items-center gap-1.5" style={{ color: accent }}>
          <Sparkles className="w-3.5 h-3.5" /> Frase del día
        </p>
        <p className="mt-1.5 text-lg font-extrabold text-[#2F2F2F]" data-testid="camino-frase-texto">«{frase.frase}»</p>
        <p className="mt-1 text-sm text-gray-700 leading-relaxed">{frase.significado}</p>
        <div className="mt-3 space-y-2 border-t border-dashed pt-3" style={{ borderColor: `${accent}66` }}>
          {[['en', 'EN', frase.en], ['de', 'DE', frase.de]].map(([key, label, t]) => (
            <div key={key} className="flex gap-2 text-xs leading-relaxed" data-testid={`camino-frase-${key}`}>
              <span className="flex-shrink-0 w-7 h-5 rounded-md bg-white text-[10px] font-bold flex items-center justify-center" style={{ color: accent }}>{label}</span>
              <p className="text-gray-700"><strong className="text-[#2F2F2F]">{t.frase}</strong> · {t.significado}</p>
            </div>
          ))}
        </div>
        <p className="mt-2 text-xs text-gray-500 italic">Mañana hay una nueva. Vuelve a escanear la pegatina y sigue aprendiendo.</p>
      </div>
      <div className="rounded-xl bg-[#E8F5FA] px-4 py-4 text-center">
        <p className="text-sm font-semibold text-[#2F2F2F]">¿Quieres aprender más español durante el Camino?</p>
        <p className="mt-1 text-xs text-gray-600">Sígueme y descubre nuevas frases, vocabulario y expresiones.</p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="camino-thanks-instagram"
          className="mt-3 inline-flex items-center gap-2 px-6 py-3 rounded-full text-white font-bold text-sm shadow-md active:scale-95 transition-transform"
          style={{ background: 'linear-gradient(90deg, #E38987, #7DBDD9)' }}
        >
          <Instagram className="w-4 h-4" />
          Seguir en Instagram
        </a>
      </div>
    </div>
  </motion.div>
  );
};
